<script>
import { mapGetters } from 'vuex';
import { Howl } from 'howler';
import Player from 'ne01-common/src/components/Player';
import InfoButton from 'ne01-common/src/components/InfoButton';

export default {
  name: 'SpectroPage',
  components: {
    Player,
    InfoButton
  },
  data: () => ({
    showButton: false,
    totalSteps: 3,
  }),
  mounted() {
    this.playVoiceover(this.voiceover);
    document.addEventListener('click', this.countClick);
  },
  methods: {
    nextStep() {
      if (this.currentStep < this.totalSteps) {
        this.scrollToTop();
        this.$store.dispatch('nextStep');
        this.showButton = false;
        this.playVoiceover(this.voiceover);
      } else {
        this.$emit('unloadStation');
      }
    },
    playVoiceover(voiceover) {
      let sound = new Howl({ src: [voiceover] });
      sound.on('end', () => { this.showButton = true; });
      sound.play();
    },
    countClick() {
      if (!this.stationEnd)
        this.$store.dispatch('clickCount');
    },
    scrollToTop() {
      if (document.getElementsByClassName('station-content').length > 0)
        document.getElementsByClassName('station-content')[0].scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    },
  },
  computed: {
    ...mapGetters({
      verses: 'getCurrentVerses',
      currentStep: 'getCurrentStep',
      voiceover: 'getCurrentVoiceover',
      instruction: 'getCurrentInstruction',
      infoButton: 'getCurrentInfopage',
      statisticsTotals: 'getStatisticsTotals',
      visitorId: 'getVisitorId',
    }),
  },
  destroyed() {
    document.removeEventListener('click', this.countClick);
  },
};
</script>

<template>
  <div class="spectro">
    <div class="spectro__content">
      <p class="spectro__instruction">{{instruction}}</p>
      <div class="spectro__players" v-for="(item, index) in verses" :key="index">
        <player 
            class="spectro__player"
            v-bind:key="item.verse"
            v-bind:src="item.verse" 
            v-bind:title="item.title" 
            spectroImg controls showProgress 
            v-bind:speeds="[100, 50, 20]">
        </player>
      </div>
      <InfoButton class="spectro__info-button" v-if="infoButton && infoButton[0]" v-bind:id="infoButton[0]" :key="infoButton[0]" />
      <InfoButton class="spectro__info-button" v-if="infoButton && infoButton[1]" v-bind:id="infoButton[1]" :key="infoButton[1]" />
    </div>
    <div class="spectro__actions">
      <transition name="button-transition">
        <button v-if="showButton" class="spectro__button common-button" v-on:click="nextStep">
          <span v-if="currentStep < totalSteps">{{$t('quiz.next')}}</span>
          <span v-if="currentStep >= totalSteps">{{$t('quiz.unloadStation')}}</span>
        </button>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.spectro {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.spectro__instruction {
  font-size: 2rem;
  line-height: 1.34;
  max-width: 36rem;
  margin: 3rem 0 3rem;
  padding: 0 calc(var(--gutter) * 3);
}
.spectro__player {
  margin: 1rem 0;
}
.spectro__info-button {
  margin-top: 3rem;
}
.spectro__actions {
  margin-top: 5rem;
}
.button-transition-enter-active {
  transform-origin: 50% 300%;
  transition: 100ms opacity linear 600ms, 666ms transform cubic-bezier(.8,.3,.25,1.66) 450ms;
}
.button-transition-enter {
  opacity: 0;
  transform: translate3d(0, 0, 20rem) rotateX(-80deg) skewY(-10deg);
}
.button-transition-leave-active {
  transition: 100ms opacity linear 150ms, 666ms transform cubic-bezier(.8, .3, .25, 1.66);
  transform-origin: 50% -300%;
}
.button-transition-leave-to {
  opacity: 0;
  transform: translate3d(0,0,20rem) rotateX(80deg) skewY(10deg) scale(1.2);
}
</style>